import type { AuditAction, AuditEntry, ClassificationResult, ClientRecord } from '../domain/types';
import { appendAudit } from './db';

function newId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Should never happen in supported browsers; fallback is non-cryptographic.
  return `audit-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export async function recordAudit(params: {
  action: AuditAction;
  actor: string;
  record: ClientRecord;
  classification: ClassificationResult;
}): Promise<AuditEntry> {
  const entry: AuditEntry = {
    id: newId(),
    timestamp: new Date().toISOString(),
    actor: params.actor,
    action: params.action,
    clientId: params.record.client_id,
    payload: params.record,
    computedTier: params.classification.tier,
    reasons: params.classification.reasons,
    rulesVersion: params.classification.rulesVersion,
  };
  await appendAudit(entry);
  return entry;
}
